export {
  default as largeBackyard,
  ReactComponent as LargeBackyard,
} from '@assets/icons/spaces/large-backyard.svg'    
